import type { LinkProps } from 'expo-router'

import { Typography } from '../text/Typography'
import { useListboxItem, type TListboxItemProps } from './useListboxItem'

export const ListboxItem = ({ ref, ...props }: TListboxItemProps) => {
  const { Component, children, startContent, endContent, getItemProps, getLabelProps } = useListboxItem(props)

  // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- narrowed to Link branch
  const itemProps = getItemProps() as LinkProps

  return (
    <Component {...itemProps} ref={ref}>
      {startContent}
      <Typography {...getLabelProps()}>{children}</Typography>
      {endContent}
    </Component>
  )
}

ListboxItem.displayName = 'ListboxItem'
